import { call, put, takeEvery, select } from "redux-saga/effects";
import {
  getStudentEvents,
  getStudentEvent,
  signUpForStudentEvent,
  withdrawFromStudentEvent,
} from "src/web-services";
import { Notification } from "src/helpers";
import i18n from "src/i18n";
import {
  StudentEventsCreators,
  StudentEventsTypes,
} from "../actions";

const authTokenSelector = state => state.user.authToken;

export function* watchStudentEventsRequests() {
  yield takeEvery(
    StudentEventsTypes.GET_STUDENT_EVENTS_REQUEST,
    requestGetStudentEvents,
  );
  yield takeEvery(
    StudentEventsTypes.GET_STUDENT_EVENT_REQUEST,
    requestGetStudentEvent,
  );
  yield takeEvery(
    StudentEventsTypes.SIGN_UP_FOR_EVENT_REQUEST,
    requestSignUpForEvent,
  );
  yield takeEvery(
    StudentEventsTypes.WITHDRAW_FROM_EVENT_REQUEST,
    requestWithdrawFromEvent,
  );
}

export function* requestGetStudentEvents(action) {
  try {
    const { params, resolve } = action;
    const authToken = yield select(authTokenSelector);

    const response = yield call(getStudentEvents, authToken, params);

    resolve && resolve();
    yield put(
      StudentEventsCreators.getStudentEventsSuccess(
        response.data,
        params,
      ),
    );
  } catch (error) {
    action.reject && action.reject(error);
    yield put(StudentEventsCreators.getStudentEventsFailure());
  }
}

export function* requestGetStudentEvent(action) {
  try {
    const { eventId } = action;
    const authToken = yield select(authTokenSelector);

    const response = yield call(getStudentEvent, authToken, eventId);

    yield put(
      StudentEventsCreators.getStudentEventSuccess(
        response.data.event,
      ),
    );
  } catch (error) {
    yield put(StudentEventsCreators.getStudentEventFailure());
  }
}

export function* requestSignUpForEvent(action) {
  try {
    const { eventId, eventName } = action;
    const authToken = yield select(authTokenSelector);

    const response = yield call(
      signUpForStudentEvent,
      authToken,
      eventId,
    );

    yield put(
      StudentEventsCreators.signUpForEventSuccess(
        response.data.event,
      ),
    );
    Notification.success(
      i18n.t("events.student.registered_toast", { name: eventName }),
    );
  } catch (error) {
    // API.request already surfaces the server's message; this only unwinds
    // the saving flag so the button becomes clickable again.
    yield put(StudentEventsCreators.signUpForEventFailure());
  }
}

export function* requestWithdrawFromEvent(action) {
  try {
    const { eventId, eventName } = action;
    const authToken = yield select(authTokenSelector);

    const response = yield call(
      withdrawFromStudentEvent,
      authToken,
      eventId,
    );

    yield put(
      StudentEventsCreators.withdrawFromEventSuccess(
        response.data.event,
      ),
    );
    Notification.success(
      i18n.t("events.student.withdrawn_toast", { name: eventName }),
    );
  } catch (error) {
    yield put(StudentEventsCreators.withdrawFromEventFailure());
  }
}
